import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('NavBar').create(({ theme }) => ({
  bottomNav: {
    '.Mui-selected': {
      color: theme.colors.text.primary,
      opacity: '1',
    },
    button: {
      opacity: '0.4',
    },
    overflowX: 'hidden',
    overflowY: 'hidden',
  },

  bottomNavButton: {
    height: '100%',
    borderRadius: '12px',
    color: 'white',
    display: 'flex',
    gap: '6px',
  },

  bottomNavItem: {
    color: theme.colors.text.secondary,
  },
}))
